
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.64 16.6"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M4.47 6.39h5.76v1H4.47zM4.47 9.03h5.76v1H4.47z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.79 9.05l.38-1.69H8.14l-.38 1.69h1.03zM9.39 6.42l.37-1.61-.97-.22-.42 1.83h1.02zM7.54 10l-.38 1.65.98.23.42-1.88H7.54zM7.02 6.42l.37-1.61-.98-.22L6 6.42h1.02zM5.16 10l-.37 1.65.97.23.43-1.88H5.16zM6.41 9.05l.38-1.69H5.77l-.39 1.69h1.03z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M7.32 16.6l-.77-.49A13.35 13.35 0 0 1 0 4.62l.08-1.33h1.34a6.83 6.83 0 0 0 4.8-2L7.33 0l1.1 1.3a6.63 6.63 0 0 0 4.79 2h1.34l.07 1.33a13.35 13.35 0 0 1-6.54 11.48zm-.24-1.34l.24.15.24-.15a12.33 12.33 0 0 0 6.08-10.58v-.42h-.44A7.75 7.75 0 0 1 7.67 2l-.35-.41L7 2a7.75 7.75 0 0 1-5.56 2.26H1v.42a12.3 12.3 0 0 0 6.08 10.58z"}})])])])
          )
        }
      }
    